import css from './index.module.scss';
import EcoPicture from 'eco-design-components/base/eco-picture';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const PopupTW: React.FC = () => {
    const [isClient, setIsClient] = useState(false);
    const [show, setShow] = useState(false);

    const handleClose = (e: React.MouseEvent<SVGSVGElement>) => {
        e.stopPropagation();
        const storage = localStorage.getItem(`popup_tw_coolstershop`);
        if (storage) {
            const data = JSON.parse(storage);
            data.closed += 1;
            localStorage.setItem('popup_tw_coolstershop', JSON.stringify(data));
        } else {
            localStorage.setItem(
                'popup_tw_coolstershop',
                JSON.stringify({
                    closed: 1,
                    occured: 1,
                    timestamp: Date.now(),
                }),
            );
        }
        setShow(false);
    };

    const handleJump = () => {
        // setShow(false);
        window.open('https://www.coolstershop.com/', '_blank');
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const timer = setTimeout(() => {
                setIsClient(true);
                const storage = localStorage.getItem(`popup_tw_coolstershop`);
                if (!storage) {
                    setShow(true);
                    localStorage.setItem(
                        'popup_tw_coolstershop',
                        JSON.stringify({
                            closed: 0,
                            occured: 1,
                            timestamp: Date.now(),
                        }),
                    );
                } else {
                    // closed 用户主动关闭次数； occured刷新页面即出现的次数, timestamp记录是否一天内/24h
                    const { closed = 0, occured = 0, timestamp } = JSON.parse(storage);
                    const flag = (!closed || closed < 2) && (!occured || occured < 3);
                    setShow(flag);
                    const now = Date.now();
                    // 超过一天重置storage
                    const data =
                        now - timestamp > 24 * 60 * 60 * 1000
                            ? {
                                  closed: 0,
                                  occured: 1,
                                  timestamp: now,
                              }
                            : {
                                  closed,
                                  occured: occured + 1,
                                  timestamp,
                              };
                    if (flag) {
                        localStorage.setItem('popup_tw_coolstershop', JSON.stringify(data));
                    }
                }
            }, 5000);
            return () => {
                if (timer) clearTimeout(timer);
            };
        }
    }, []);

    return (
        <>
            {isClient &&
                show &&
                createPortal(
                    <div className={`${css['popup-tw']} popup-tw`}>
                        <div className="popup-content" onClick={handleJump}>
                            <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={handleClose}>
                                <g opacity="0.8">
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M12 2.80005C14.5403 2.80005 16.8403 3.82993 18.5052 5.49486C20.1702 7.15979 21.2001 9.45978 21.2001 12C21.2001 14.5403 20.1702 16.8403 18.5052 18.5052C16.8403 20.1702 14.5403 21.2001 12 21.2001C9.45978 21.2001 7.15979 20.1702 5.49486 18.5052C3.82993 16.8403 2.80005 14.5403 2.80005 12C2.80005 9.45978 3.82993 7.15979 5.49486 5.49486C7.15979 3.82993 9.45978 2.80005 12 2.80005Z"
                                        stroke="white"
                                        stroke-width="1.6"
                                    ></path>
                                    <path
                                        d="M8.5 8.5L15.5 15.5M15.5 8.5L8.5 15.5"
                                        stroke="white"
                                        stroke-width="1.6"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    ></path>
                                </g>
                            </svg>
                            <EcoPicture
                                jpg={[
                                    'https://websiteoss.ecoflow.com/upload/image/1766999605956/pc.jpg',
                                    'https://websiteoss.ecoflow.com/upload/image/1766999606164/h5.jpg',
                                ]}
                            />
                        </div>
                    </div>,
                    document.body,
                )}
        </>
    );
};

export default PopupTW;
